import React, { createRef } from "react";
import {
  Layout,
  Space,
  Form,
  PageHeader,
  Input,
  Row,
  Col,
  Button,
} from "antd";
import { useMediaQuery } from 'react-responsive'
import { addToWaitlist } from "../../services/WaitListService";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { notify } from "../../utils/notification";

const { Content } = Layout;

const CustomerWaitlist = () => {
  const restaurantId = useSelector((state) => state.admin);
  const formRef = createRef();
  const [form] = Form.useForm();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 767 });
  const history = useHistory();
  const params = useParams();

  const handleSubmit = async (values) => {
    const payload = {
      "name": values.name,
      "email": values.email,
      "phone": values.phone,
      "num_people": Number(values.count),
    }
    try {
      const waitlist = await addToWaitlist(payload, restaurantId);
      if (waitlist.length) {
        const res = waitlist[0];
        history.push(`/restaurant/${params.restaurantCode}/waitlist/${res.id}`)
      }
    } catch (error) {
      notify({ type: 'error', message: "Couldn't add you to waitlist", description: 'Please try again'});
    }
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full">
        <Space className="w-full" direction="vertical">
          <PageHeader
            className="pl-0"
            title="Boulder Burrito's Waitlist"
            extra={
              [
                // <Button
                //   type="primary"
                //   onClick={() => history.push("/delivery/manage-orders")}
                // >
                //   Manage Orders
                // </Button>,
              ]
            }
          />
        </Space>
        <div className={isTabletOrMobile ? 'p-1' : "site-layout-background p-1"}>
          <h3 className="theme-red text-left">Add Details</h3>
          <Form
            ref={formRef}
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
          >
            <Row gutter={16}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="Enter your Name" autoComplete="name" autoCapitalize="" />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="phone"
                  label="Mobile Number"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input bordered placeholder="Enter your mobile number" autoComplete="tel" />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                >
                  <Input bordered placeholder="Enter your email id" autoComplete="email" />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="count"
                  label="Number of People"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    bordered
                    placeholder="Enter the number of people in your Party"
                    type="number"
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="text-center">
              <Button type="primary" htmlType="submit" className="px-3" size="large">
                Save
              </Button>
            </div>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default CustomerWaitlist;
